import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../material.module';
import { LanguagesTranslateFuseComponent } from './languages-translate-fuse.component';

/**
 * Module léger pour le sélecteur de langue Fuse (évite les imports circulaires
 * avec FeatureFuseModule depuis les composants standalone).
 */
@NgModule({
    declarations: [LanguagesTranslateFuseComponent],
    imports: [CommonModule, MaterialModule, TranslateModule],
    exports: [LanguagesTranslateFuseComponent],
})
export class LanguagesTranslateFuseModule {}
